module.exports = __webpack_public_path__ + "img/blockImgLanding-1050.89215039.webp";